// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","PlusBadge":"bcz_a bhm_rj bhm_rk bhm_vh bhm_eb bhm_vf bhm_gs bhm_kh"};